import { createSlice } from "@reduxjs/toolkit";
import userServices from "../services/userRoutes";

/* ------------------- GENERATE UNIQUE KEY ------------------- */
function generateKey(item) {
  if (!item.selectedVariants || item.selectedVariants.length === 0) {
    return item._id;
  }

  const variantIds = item.selectedVariants
    .map(
      (v) =>
        v.variantValueId || `${v.variantKey}:${v.variantValue || ""}`.trim()
    )
    .sort();

  return `${item._id}-${variantIds.join("|")}`;
}

/* --------------------- LOAD LOCAL STORAGE --------------------- */
const loadInitialWishlist = () => {
  try {
    const raw = localStorage.getItem("wishlistItems");
    if (!raw) return [];
    const parsed = JSON.parse(raw);

    return parsed.map((item) => ({
      ...item,
      key: item.key || generateKey(item),
    }));
  } catch {
    return [];
  }
};

/* --------------------- INITIAL STATE --------------------- */
const initialState = {
  items: loadInitialWishlist(),
};

/* --------------------- LOCAL SAVE --------------------- */
const saveLocal = (items) =>
  localStorage.setItem("wishlistItems", JSON.stringify([...items]));

/* --------------------- SYNC TO BACKEND --------------------- */
const syncToDB = (items) => {
  const token = localStorage.getItem("accessToken");
  if (token) userServices.updateWishlist([...items]); // ⭐ FIXED
};

/* --------------------- SLICE --------------------- */
const wishlistSlice = createSlice({
  name: "wishlist",
  initialState,
  reducers: {
    addToWishlist: (state, action) => {
      const incoming = action.payload;
      const key = generateKey(incoming);

      const exists = state.items.some((p) => p.key === key);
      if (!exists) {
        state.items.push({ ...incoming, key });
      }

      saveLocal(state.items);
      syncToDB(state.items);
    },

    removeFromWishlist: (state, action) => {
      const key = action.payload;
      state.items = state.items.filter((p) => p.key !== key);

      saveLocal(state.items);
      syncToDB(state.items);
    },

    clearWishlist: (state) => {
      state.items = [];
      saveLocal([]);
      syncToDB([]);
    },

    /* ---------- MERGE AFTER LOGIN ---------- */
    mergeWishlistAfterLogin: (state, action) => {
      const dbWishlist = action.payload || [];
      let finalList = [...dbWishlist];

      state.items.forEach((localItem) => {
        if (!finalList.some((x) => x.key === localItem.key)) {
          finalList.push(localItem);
        }
      });

      state.items = finalList;

      saveLocal(finalList);
      syncToDB(finalList);
    }
  },
});

export const {
  addToWishlist,
  removeFromWishlist,
  clearWishlist,
  mergeWishlistAfterLogin,
} = wishlistSlice.actions;

export default wishlistSlice.reducer;
